<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Update Setting HPP</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="3" xl="3">
            <v-text-field
              v-model.number="item.percentage"
              label="Percentage"
              outlined
              dense
              flat
              background-color="white"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" @click="close">
          close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-update-setting",
  props: {
    dialog: Boolean,
    item: Object,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.item);
    },
  },
};
</script>

<style></style>
